import { FilterOperator } from './../../../base/models/models.swagger.generated';
import { IAdaptorService } from './../../../base/shared/syncfusion/adaptor-service.interface';
import { ToastService } from '../../../base/services/toast.service';
import { ClientClient, ClientDTO, PagedResultDTOOfClientDTO, CreateClientDTO, UpdateClientDTO, FilterDTO, SortDirection } from '../../../base/models/models.swagger.generated';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ErrorType } from 'src/app/core/routing/error-types';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';

@Injectable({
  providedIn: 'root'
})
export class ClientAdministrationService extends ShowInactiveService implements IAdaptorService {

  constructor(
    private clientAdministrationClient: ClientClient,
    private toastService: ToastService,
  ) {
    super();
   }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<PagedResultDTOOfClientDTO> {

    if (!this.showInactive) {
      if (!filters) {
        filters = [];
      }
      filters.push(new FilterDTO({isComplex: false, field: 'Active', operator: FilterOperator.Equal, value: 'true'}));
    }

    return this.clientAdministrationClient.searchClients(skip, take, sortBy, sortDirection, null, null, filters)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public updateRecord(data: UpdateClientDTO): Observable<ClientDTO> {
    return this.clientAdministrationClient.updateClient(data)
      .pipe(
        tap(() => {
          this.toastService.showSuccess('i18n.domain.client-administration.messages.update-title', 'i18n.domain.client-administration.messages.update-success-message');
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError, error.response);
          }
          return throwError(() => error);
        }),
      );
  }

  public addRecord(data: CreateClientDTO): Observable<ClientDTO> {
    return this.clientAdministrationClient.createClient(data)
      .pipe(
        tap(() => {
          this.toastService.showSuccess('i18n.domain.client-administration.messages.add-title', 'i18n.domain.client-administration.messages.add-success-message');
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError, error.response);
          }
          return throwError(() => error);
        }),
      );
  }

  public deleteRecord(id: number): Observable<any> {
    return this.clientAdministrationClient.deleteClient(id)
      .pipe(
        tap(() => {
          this.toastService.showSuccess('i18n.domain.client-administration.messages.delete-title', 'i18n.domain.client-administration.messages.delete-success-message');
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', error.response, null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }
}
